import Store from 'redux/store';
import { FETCH_CATALOG, FETCH_CATALOG_FAIL, FETCH_CATALOG_SUCCESS } from 'redux/Reducers/Catalog/CatalogReducer';
import { cloudloyalty } from '../clients';

const FetchCatalog = async (User, finallyCallback = () => {}) => {
  Store.dispatch({ type: FETCH_CATALOG });
  cloudloyalty(User).get('/v1/configurations/catalogs/byToken').then((response) => {
    Store.dispatch({
      type: FETCH_CATALOG_SUCCESS,
      payload: {
        ...response,
      },
    });
  }).catch((e) => {
    Store.dispatch({
      type: FETCH_CATALOG_FAIL, error: e,
    });
  })
    .finally(() => {
      finallyCallback();
    });
};

export default FetchCatalog;
